export const PHONE_NUMBER_PATTERN =
  /^\+7[\s\u00A0]\d{3}[\s\u00A0]\d{3}[\s\u00A0]\d{2}[\s\u00A0]\d{2}$/;
